const bimg = (id, crop = "entropy", w = 1400) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop&crop=${crop}`;

const B1 = bimg("photo-1519823551278-64ac92734fb1", "edges");
const A1 = bimg("photo-1519824145371-296894a0daa9", "faces");
const I1 = bimg("photo-1600210492486-724fe5c67fb0", "top");
const L1 = bimg("photo-1519710164239-da123dc03ef4", "top");

export const RELAX_POSTS = [
  {
    slug: "swedish-massage-edmonton",
    title: "What Is Swedish Massage and Who Is It For?",
    keyword: "Swedish massage Edmonton",
    category: "Relaxation, Swedish & Hot Stone",
    read: "4 min read",
    img: B1,
    excerpt:
      "The classic of Western massage: long, flowing strokes and calming rhythm. What Swedish massage actually is — and who it serves best.",
    body: [
      {
        p: [
          "Swedish massage is the foundation of Western massage therapy: long gliding strokes, gentle kneading and rhythmic movements, performed with oil at a pressure that is light to medium and always negotiable. If you have ever pictured “a massage”, you were picturing Swedish.",
        ],
      },
      {
        h: "What it does best",
        p: [
          "Swedish massage is unmatched at changing state: calming the nervous system, easing general muscle tension, improving circulation and simply giving the body permission to rest. It is maintenance and recovery in their gentlest form.",
        ],
      },
      {
        h: "Who it suits",
        p: [
          "Almost everyone — but especially first-time clients, people under heavy stress, those sensitive to deep pressure, and anyone whose main complaint is “tired” rather than “injured”. If deep tissue is repair, Swedish is restoration. At Royal Essence in Edmonton, the two are often blended in a single session.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "relaxation-massage-first-session",
    title: "Relaxation Massage: What to Expect at Your First Session",
    keyword: "relaxation massage near me",
    category: "Relaxation, Swedish & Hot Stone",
    read: "4 min read",
    img: I1,
    excerpt:
      "A walkthrough of a first relaxation session — from the short health conversation to the moment you float out — so nothing is unknown.",
    body: [
      {
        p: [
          "First sessions come with unnecessary nerves. Here is exactly how it goes, so the only surprise is how good you feel after.",
        ],
      },
      {
        h: "Before the massage",
        p: [
          "You will fill in a short health history and have a brief conversation — what brings you in, any areas to focus on or avoid, pressure preferences. Then you are left in privacy to undress to your comfort level and settle under the sheets on a warm table.",
        ],
      },
      {
        h: "During and after",
        p: [
          "You are professionally draped throughout — only the area being worked is uncovered. Talking is welcome and silence is equally welcome. Afterwards, take your time getting up; expect to feel loose and pleasantly unhurried, and drink some water.",
          "One tip: book your first session on a day without a hard deadline after it. The calm is worth keeping.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "best-massage-for-relaxation",
    title: "Which Massage Is Best for Pure Relaxation?",
    keyword: "best massage for relaxation",
    category: "Relaxation, Swedish & Hot Stone",
    read: "3 min read",
    img: L1,
    excerpt:
      "When the goal is simply to switch off — Swedish, hot stone, or something blended. A short guide to maximum exhale.",
    body: [
      {
        p: [
          "If the goal is not to fix anything but to feel human again, two styles lead the field: Swedish relaxation massage and hot stone massage.",
        ],
      },
      {
        h: "Swedish: the classic exhale",
        p: [
          "Long, flowing strokes and calming rhythm at a pressure you choose. Swedish is the reference point for deep relaxation — predictable in the best way, and endlessly adaptable to how tired or tender you arrive.",
        ],
      },
      {
        h: "Hot stone: relaxation with warmth",
        p: [
          "Heated stones add penetrating warmth that softens muscle before the hands even begin. Many clients find they relax faster and deeper with heat — especially in winter, and especially if being cold is their default state.",
          "Truly torn? Book either and say “relaxation is the goal today” — the session will be shaped accordingly, blending techniques as your body responds.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "relaxation-massage-benefits",
    title: "The Benefits of Relaxation Massage Under Stress",
    keyword: "relaxation massage benefits",
    category: "Relaxation, Swedish & Hot Stone",
    read: "4 min read",
    img: A1,
    excerpt:
      "Relaxation is not the absence of treatment — under sustained stress, it is the treatment. What regular relaxation massage actually changes.",
    body: [
      {
        p: [
          "“Just” a relaxation massage is undersold by its name. Under sustained stress, the body lives in low-grade emergency: elevated cortisol, guarded muscles, shallow sleep. Relaxation massage addresses exactly that physiology.",
        ],
      },
      {
        h: "What it changes",
        p: [
          "Sessions shift the nervous system toward rest: heart rate and blood pressure ease, muscle guarding releases, and sleep that night is usually measurably deeper. Over a regular rhythm — monthly or more — clients commonly report a lower stress baseline, not just a good hour.",
        ],
      },
      {
        h: "The compounding effect",
        p: [
          "Each session also teaches the body the route back to calm. Over time, clients find they can approach that state more easily on their own — the massage table becomes training for the nervous system, not an escape from life.",
        ],
      },
    ],
    note:
      "Relaxation massage pairs well with — but does not replace — professional care for ongoing anxiety, burnout or low mood.",
  },
  {
    slug: "hot-stone-massage-edmonton",
    title: "What Is a Hot Stone Massage?",
    keyword: "hot stone massage Edmonton",
    category: "Relaxation, Swedish & Hot Stone",
    read: "4 min read",
    img: B1,
    excerpt:
      "Smooth basalt stones, warmed and gliding. What hot stone massage involves, who loves it, and why winter in Edmonton is its natural habitat.",
    body: [
      {
        p: [
          "Hot stone massage places smooth, heated basalt stones on key points of the body and uses them as warm extensions of the therapist's hands — gliding slowly along muscles, radiating heat several layers deep. It is the warmest massage you will ever have, in every sense.",
        ],
      },
      {
        h: "What the heat does",
        p: [
          "Warmth softens muscle and fascia before pressure is applied, so the therapist can achieve deep release with gentler input. Circulation increases, and the nervous system reads sustained warmth as profound safety — many clients drift into a near-sleep state.",
        ],
      },
      {
        h: "Who loves it",
        p: [
          "The chronically cold, the deeply stressed, the winter-weary, and anyone whose muscles respond better to warmth than to pressure. During an Edmonton winter, hot stone season is practically a public service.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "hot-stone-vs-deep-tissue-massage",
    title: "Hot Stone vs. Deep Tissue Massage: How to Choose",
    keyword: "hot stone vs deep tissue massage",
    category: "Relaxation, Swedish & Hot Stone",
    read: "3 min read",
    img: A1,
    excerpt:
      "Both release deep tension — one through warmth, one through pressure. Choosing by what your body responds to.",
    body: [
      {
        p: [
          "Hot stone and deep tissue both reach chronic tension, but by opposite doors. Deep tissue works through slow, specific pressure. Hot stone works through penetrating warmth that persuades the muscle to release before much pressure is needed.",
        ],
      },
      {
        h: "Choose hot stone when…",
        p: [
          "You want deep release without deep pressure; you run cold; the goal is comfort as much as change; or deep pressure has felt like too much in the past.",
        ],
      },
      {
        h: "Choose deep tissue when…",
        p: [
          "There is a specific spot to change — a knot, a restriction, a stubborn pattern. Deep tissue is the more targeted instrument.",
          "They combine beautifully: stones to soften, hands to resolve. Ask for a blended session if you want both doors open.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "hot-stone-massage-contraindications",
    title: "Who Should Avoid Hot Stone Massage?",
    keyword: "hot stone massage contraindications",
    category: "Relaxation, Swedish & Hot Stone",
    read: "3 min read",
    img: I1,
    excerpt:
      "Heat is therapeutic for most bodies — but not all. The situations where hot stone waits, and the alternatives that fit instead.",
    body: [
      {
        p: [
          "Hot stone massage is safe for most people, but sustained heat is a real physiological input, and a few conditions change the answer.",
        ],
      },
      {
        h: "When hot stone is not the right choice",
        p: [
          "Reduced skin sensitivity or neuropathy (including advanced diabetes) — because reduced sensation makes judging heat unsafe. Circulatory conditions, uncontrolled high blood pressure, or a history of blood clots — heat demands more of circulation. Pregnancy — deep heating is best avoided; a gentle prenatal session is the right format instead. And any acute inflammation, fresh injury, fever, or sunburned or broken skin.",
        ],
      },
      {
        h: "When in doubt",
        p: [
          "Mention any condition when booking — hot stone can often be adapted with lower temperatures and shorter contact, or swapped for a warm but stone-free session. A quick word with your physician settles medical questions definitively.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "what-to-wear-to-a-massage",
    title: "What to Wear to a Massage (and Other First-Visit Questions)",
    keyword: "what to wear to a massage",
    category: "Relaxation, Swedish & Hot Stone",
    read: "3 min read",
    img: L1,
    excerpt:
      "Short answer: whatever you arrived in. The draping, the undressing-to-comfort-level, and every other small unknown, answered.",
    body: [
      {
        p: [
          "The most-asked first-visit question has the simplest answer: wear whatever you like. You will undress privately to your personal comfort level — for most people that is down to underwear — and you will be professionally draped under sheets the entire session, with only the area being worked uncovered.",
        ],
      },
      {
        h: "The practical details",
        p: [
          "Skip heavy perfume and a large meal right before. Jewellery comes off. Long hair is best tied loosely. Arrive five to ten minutes early for the health form and a moment to land — arriving rushed takes half the session to unwind.",
        ],
      },
      {
        h: "The other quiet worry",
        p: [
          "Many first-timers worry about bodies — theirs, being seen or judged. Massage therapists work with every kind of body, every day, with complete professional neutrality. The table is a no-judgement zone by design.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "couples-massage-edmonton",
    title: "Couples Massage or Two Solo Sessions: What to Choose",
    keyword: "couples massage Edmonton",
    category: "Relaxation, Swedish & Hot Stone",
    read: "3 min read",
    img: I1,
    excerpt:
      "Sharing a room versus having the therapist's full attention — the honest trade-offs of a couples booking.",
    body: [
      {
        p: [
          "A couples massage puts two tables in one room with two therapists, so you share the experience in real time. It is a lovely format — with a few honest trade-offs worth knowing before you book.",
        ],
      },
      {
        h: "When couples format shines",
        p: [
          "Anniversaries, birthdays, introducing a nervous first-timer to massage with a familiar person nearby, or simply turning care into a shared ritual. The togetherness is the point, and it delivers.",
        ],
      },
      {
        h: "When solo serves better",
        p: [
          "If one of you has a specific issue to work on — an injury, chronic pain, TMJ — a solo session gives that work the full appointment and the full attention. Many couples alternate: shared sessions for occasions, solo sessions for maintenance.",
          "Whichever you choose, book early — coordinating two therapists means couples slots are the first to fill.",
        ],
      },
    ],
    note: null,
  },
];
